const UNIT_CODE_PREFIX = 'U-';
const MAX_UNIT_CODE_LENGTH = 32;
const MAX_RANDOM_LENGTH = MAX_UNIT_CODE_LENGTH - UNIT_CODE_PREFIX.length;

export function createInternalUnitCode(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    const random = crypto.randomUUID().replace(/-/g, '').toUpperCase();
    return `${UNIT_CODE_PREFIX}${random.slice(0, MAX_RANDOM_LENGTH)}`;
  }

  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).slice(2).toUpperCase();
  const combined = `${timestamp}${random}`.replace(/[^A-Z0-9]/g, '');
  return `${UNIT_CODE_PREFIX}${combined.slice(0, MAX_RANDOM_LENGTH)}`;
}
